module.exports = __webpack_public_path__ + "img/events.01ddd143.svg";